module.exports = "/_next/static/images/box-524fd05240dfbae61a4af5beadfe55a5.svg";